class PayByInvoiceModal extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.trigger = this.querySelector('[data-invoice-open]');
    if (!this.dialog || !this.trigger) return;

    this.onOpen = (event) => {
      event.preventDefault();
      this.dialog.showModal();
    };

    this.onClick = (event) => {
      if (event.target.closest('[data-invoice-close]')) {
        event.preventDefault();
        this.dialog.close();
        return;
      }

      if (event.target.closest('[data-invoice-add]')) {
        event.preventDefault();
        this.addToCart();
        return;
      }

      // Click on the backdrop (the dialog element itself) closes it.
      if (event.target === this.dialog) this.dialog.close();
    };

    this.trigger.addEventListener('click', this.onOpen);
    this.dialog.addEventListener('click', this.onClick);
  }

  // Reuse the theme's own add-to-cart button so variant selection, inventory
  // rules and the cart drawer all behave exactly as they do normally.
  addToCart() {
    const form = this.closest('.shopify-section, section')?.querySelector('form[action*="/cart/add"]');
    const button = form?.querySelector('[type="submit"]');

    this.dialog.close();

    if (button) {
      button.click();
    } else if (form) {
      form.submit();
    }
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this.onOpen);
    this.dialog?.removeEventListener('click', this.onClick);
  }
}

if (!customElements.get('pay-by-invoice-modal')) {
  customElements.define('pay-by-invoice-modal', PayByInvoiceModal);
}